import { render, staticRenderFns } from "./PayPage.vue?vue&type=template&id=5ebf807a&"
import script from "./PayPage.vue?vue&type=script&lang=js&"
export * from "./PayPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports